import AppConfig from './app.config'
import { app } from './app'
var isBrowser = typeof window !== 'undefined'

app.$mount('#app')

if (isBrowser) {
  const browserUpdate = require('browser-update')
  browserUpdate(AppConfig.browserUpdateConf)
  window.r = app._router
}
